import React from "react";
import { Link } from "react-router-dom";
import moment from "moment";
import db from "../../firebase";  
// For structuring, styling and icons
import Grid from "@material-ui/core/Grid";
import Button from '@material-ui/core/Button';
import VisibilityIcon from '@material-ui/icons/Visibility';
import ShareIcon from '@material-ui/icons/Share';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import ArchiveIcon from '@material-ui/icons/Archive';
import LabelIcon from '@material-ui/icons/Label';
import EditIcon from '@material-ui/icons/Edit';

function PostPreview(props) {

  // Function for hiding and showing delete blog promp
  const delIconHandler = (event) => {
    console.log(event.currentTarget.type);
  }

  // Function for deleting posts
  const deleteHandler = (event) => {
    event.stopPropagation();
    let docId = event.currentTarget.id;
    db.collection("blogs").doc(docId).delete();
  }

  return (
    <Grid container direction="row" className="postPreviewItem">
      {/* Featured Image */}
      <Grid item xs={1}>
        <Link to={`/posts/${props.title}`}><img className="adminPostImg" src={props.featuredImg} alt="" /></Link>
      </Grid>
      {/* Other Parts except Featred Image */}
      <Grid item container direction="column" xs={11}>
        {/* Title, author and controls */}
        <Grid item container direction="row" justifyContent="space-between">
          {/* Title */}
          <Grid item>
            {props.title}
          </Grid>
          {/* Author and controls */}
          <Grid item>
            <Link to={`/posts/${props.title}`}><VisibilityIcon /></Link>
            <DeleteForeverIcon onClick={delIconHandler}/>
            <LabelIcon />
            {props.username === props.author ? <Link to={`/admin/editPost/${props.title}`}><EditIcon /></Link> : <EditIcon />}
            <ArchiveIcon />
            <span>{props.author}</span>
          </Grid>
        </Grid>
        {/* Created at and share icon */}
        <Grid item container direction="row" justifyContent="space-between">
          <Grid item>
            <p>Created at {moment(props.createdAt.toDate()).calendar()}</p>
          </Grid>
          <Grid item>
            <span /*style={{display: "none"}}*/>
              <Button size="small" variant="outlined">
                Cancel
              </Button>
              <Button
                type="button"
                variant="contained"
                size="small"
                color="secondary"
                startIcon={<DeleteForeverIcon />}
                onClick={deleteHandler}
                id={props.docId}
              >
                Delete
              </Button>
            </span>
            <ShareIcon />
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
}

export default PostPreview;